module.exports = __webpack_public_path__ + "img/agen_affiliate_plus.16be946e.jpg";